const version = "3.5.4"; // 2024-03
export default {
  // for development
  test: {
    Region: "us-east-1",
    UserPoolId: "us-east-1_22iyRH7bX",
    ClientId: "10k76buakghp4veso09dts3bi",
    AuthUri: "https://development.frontierfield.net/auth/realms/",
    //[local] 'http://localhost:4000/auth/realms/'
    //[aws] https://development.frontierfield.net/auth/realms/
    version: version,
  },
  development: {
    Region: "ap-northeast-1",
    UserPoolId: "ap-northeast-1_V3ZTd4kmB",
    ClientId: "4btff9s5h1pd5jq7uojn6vnjfo",
    AuthUri: "https://v1.key.sandbox.medcom-apps.com/auth/realms/",
    version: version,
  },
  production: {
    Region: "ap-northeast-1",
    UserPoolId: "ap-northeast-1_cQmhvDiD7",
    ClientId: "69g7memtef4rlnvghi40tkn1h0",
    AuthUri: "https://g2.linkup.nichibyo-mobile.com/auth/realms/",
    //[g2] 'https://g2.linkup.nichibyo-mobile.com/auth/realms/'
    //[internal-g3] 'http://internal-g3.linkup.nichibyo-mobile.com/auth/realms/',
    //[g4] 'https://g4.linkup.nichibyo-mobile.com/auth/realms/'
    //[internal-g4] 'http://internal-g4.linkup.nichibyo-mobile.com/auth/realms/'
    //[internal-g4-2] 'http://internal-g4-2.linkup.nichibyo-mobile.com/auth/realms/'
    //[internal-g6] 'http://internal-g6.linkup.nichibyo-mobile.com/auth/realms/'
    //[internal-g7] 'http://internal-g7.linkup.nichibyo-mobile.com/auth/realms/'
    //[internal-g8] 'http://internal-g8.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g9] 'http://internal-g9.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g10] 'http://internal-g10.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g11] 'https://internal-g11.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g12] 'http://internal-g12.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g13] 'https://internal-g13.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g14] 'https://internal-g14.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g15] 'https://internal-g15.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g16] 'https://internal-g16.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g17] 'https://internal-g17.linkup.nichibyo-mobile.com/auth/realms/',
    //[internal-g18] 'https://internal-g18.medcom-apps.com/auth/realms/',
    //[internal-g19] 'https://internal-g19.medcom-apps.com/auth/realms/',
    //[internal-g20] 'https://internal-g20.medcom-apps.com/auth/realms/',
    //[internal-g21] 'https://internal-g21.medcom-apps.com/auth/realms/',
    //[internal-g22] 'https://internal-g22.medcom-apps.com/auth/realms/',
    //[internal-g23] 'https://internal-g23.medcom-apps.com/auth/realms/',
    //[internal-g24] 'https://internal-g24.medcom-apps.com/auth/realms/',
    //[internal-g25] 'https://internal-g25.medcom-apps.com/auth/realms/',
    //[internal-g26] 'https://internal-g26.medcom-apps.com/auth/realms/',
    //[internal-g27] 'https://internal-g27.medcom-apps.com/auth/realms/',
    //[internal-g28] 'https://internal-g28.medcom-apps.com/auth/realms/',
    version: version,
  },
};
